__turbopack_context__.v({
  "fade-in": "MobilePageTemplate-module-scss-module__mLNrNa__fade-in",
  "radialBg": "MobilePageTemplate-module-scss-module__mLNrNa__radialBg",
  "root": "MobilePageTemplate-module-scss-module__mLNrNa__root",
});
